import { ACTIONS_TYPES } from "../utils/constants";


export function appConfigsRequest() {
  return {
    type: ACTIONS_TYPES.APP_CONFIGS_REQUEST,
  }
}

export function appConfigsSuccess(response) {
  return {
    type: ACTIONS_TYPES.APP_CONFIGS_SUCCESS,
    payload: response,
  }
}

export function appConfigsFailed(response) {
  return {
    type: ACTIONS_TYPES.APP_CONFIGS_FAILED,
    payload: response,
  }
}
